
















































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMTextInput from '@/web/components/common/HMTextInput.vue';
import HMButton from '@/web/components/common/HMButton.vue';
import { style } from '@/web/utils/stripe';
import { errorToMessage } from '@/core/utils/errors';
import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  name: 'TipJarModal',
  components: { HMButton, HMTextInput, ValidationObserver },
  data() {
    return {
      stripeCompleted: false,
      stripeError: false,
      inProgress: false,
      jarSelected: null,
      tipAmount: null,
      customTipAmount: null,
      tipSuccessful: false,
      modalStage: null,
      anonUserEmail: null,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      role: 'user/role',
      studioURL: 'user/studioURL',
    }),
    tipButtonText() {
      return this.tipAmount
        ? this.$t('STUDIO.BUTTON.TIP_X_AMOUNT', {
            tipAmount: this.$formatCurrency(this.tipAmount || 0, this.currency),
          })
        : this.$t('STUDIO.BUTTON.SELECT_AN_AMOUNT');
    },
    userIsAnonymous() {
      return this.role === 'anonymous' || this.role === null;
    },
    inSelectStage() {
      return this.modalStage === this.STAGE_SELECT;
    },
    inConfirmStage() {
      return this.modalStage === this.STAGE_CONFIRM;
    },
    inFinishedStage() {
      return this.modalStage === this.STAGE_FINISHED;
    },
    currentStudio() {
      if (this.studio) {
        return this.studio;
      } else {
        try {
          return this.$store.dispatch('studio/getStudio', this.studioURL);
        } catch (e) {
          console.log(e);
          return null;
        }
      }
    },
  },
  props: {
    clickable: {
      type: Boolean,
      default: true,
    },
    studioName: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    closeButtonText: {
      type: String,
      default() {
        return this.$t('GENERAL.BUTTON.CLOSE');
      },
    },
  },
  methods: {
    selectOption(tipAmount, jarNumber) {
      this.jarSelected = jarNumber;
      this.tipAmount = tipAmount;
    },
    setCustomTipAmount() {
      this.tipAmount = parseFloat(this.customTipAmount);
      this.jarSelected = 0;
    },
    goToPayTip() {
      if (this.clickable) {
        this.initStripe();
        this.modalStage = this.STAGE_CONFIRM;
      } else {
        return;
      }
    },
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe() {
      this.stripe = window.Stripe(this.currentStudio.stripe_publishable_key);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      this.card.addEventListener('change', this.stripeChangeCallback);
      const mountTimer = setInterval(
        () => {
          if (this.$refs['card-element']) {
            this.card.mount(this.$refs['card-element']);
            clearInterval(mountTimer);
          }
        },
        50,
        100
      );
    },
    async submitTip() {
      this.inProgress = true;
      const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
      let reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
        action: 'tipsetupintent',
      });

      const tipPayload: any = {
        tipAmount: this.tipAmount,
        studioURL: this.currentStudio?.studio_url,
      };
      try {
        const setupIntent = await this.$store.dispatch(
          'studio/createTipSetupIntent',
          {
            studioURL: this.currentStudio?.studio_url,
            payload: {
              anon_user_email: this.anonUserEmail,
              token: reCaptchaToken,
            },
          }
        );
        const stripeCustomerId = setupIntent.stripe_customer_id;

        try {
          const confirmCard = await this.stripe.confirmCardSetup(
            setupIntent.setup_intent.client_secret,
            { payment_method: { card: this.card } }
          );
          if (!confirmCard.setupIntent) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Stripe card authorization failed',
              duration: -1, // stay ON
            });
            this.inProgress = false;
            return;
          }
          tipPayload.defaultPaymentMethod =
            confirmCard.setupIntent.payment_method;
          tipPayload.stripeCustomerId = stripeCustomerId;
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Stripe card authorization failed',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
          this.inProgress = false;
          return;
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Stripe error',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
        this.inProgress = false;
        return;
      }
      // send data to BE and finish tip transaction there
      try {
        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'sendtip',
        });
        tipPayload.reCaptchaToken = reCaptchaToken;
        const tipResult = await this.$store.dispatch(
          'studio/completeTip',
          tipPayload
        );
        this.tipSuccessful = true;
        this.inProgress = false;
        this.modalStage = this.STAGE_FINISHED;
        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Success',
          text: this.$tc('SETTINGS.TEXT.TIP_SUCCESSFUL'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Stripe error',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
  },
  created: function () {
    this.STAGE_SELECT = 'select';
    this.STAGE_CONFIRM = 'confirm';
    this.STAGE_FINISHED = 'finished';
    this.modalStage = this.STAGE_SELECT;
  },
});
